<template>
	<div
		class="steps__step"
		:class="( is_completed_step ) ? ' steps__step--completed' : ( is_current_step ) ? ' steps__step--active' : null"
	>
		<div class="steps__step-number">
			{{ step.step_number }}
		</div>
		<div class="steps__step-title-wrapper">
			<h2 class="steps__step-title">
				{{ step.title }}
			</h2>
			<template v-if="is_completed_step">
				<ul class="steps__step-summary">
					<li v-if="form_fields.currency">
						Currency: {{ selected_currency.label }}
					</li>
					<li v-if="form_fields.project_scope">
						Scope: {{ form_fields.project_scope.sequence_prefix ? form_fields.project_scope.sequence_prefix + ' ' : '' }}{{ form_fields.project_scope.title }}
					</li>
				</ul>
			</template>
		</div>
		<button
			v-if="is_completed_step"
			class="button button--smaller"
			type="button"
			@click="setActiveStep( step.step_number )"
		>
			Edit
		</button>
		<template v-else-if="is_current_step">
			<ProjectScopeFormComponent
				:step-title="step.title"
				@complete-form="setActiveStep( activeStepNumber + 1 )"
			/>
		</template>
	</div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import ProjectScopeFormComponent from './ProjectScopeFormComponent';
import { useAddProjectScopeStore } from '../../stores/add-project-scope';
import { storeToRefs } from 'pinia';

const add_project_scope_store = useAddProjectScopeStore();
const {
	currencies,
	form_fields
} = storeToRefs( add_project_scope_store );
const { setActiveStep } = add_project_scope_store;

const props = defineProps( {
	step: {
		required: true,
		type: Object
	},
	activeStepNumber: {
		required: true,
		type: Number
	}
} );

const selected_currency = computed( () => {
	return currencies.value.find( currency => parseInt( currency.value ) === parseInt( form_fields.value.currency ) );
} );

const is_current_step = computed( () => {
	return props.step.step_number === props.activeStepNumber;
} );

const is_completed_step = computed( () => {
	return props.step.step_number < props.activeStepNumber;
} );
</script>
